import { useNavigate, useSearch } from "@tanstack/react-router";

/**
 * Which tab is open, in the URL.
 *
 * Same reasoning as the range and contract-type filters: a link someone pastes
 * into Slack has to open on the tab they were looking at, and a reload must not
 * silently bounce them back to Overview after they drilled somewhere.
 */
export function useTabParam(fallback: string): [string, (tab: string) => void] {
  const search = useSearch({ strict: false }) as { tab?: string };
  const navigate = useNavigate();
  const tab = search.tab ?? fallback;

  const setTab = (next: string) => {
    navigate({
      to: ".",
      // replace: switching tabs is a change of view, not a new destination --
      // Back should leave the page, not walk through the tabs you opened.
      replace: true,
      search: (prev) => ({ ...prev, tab: next === fallback ? undefined : next }),
    });
  };

  return [tab, setTab];
}
